import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Button, makeStyles } from '@material-ui/core';

import { openPluginModalPage } from 'actions/modalPage';
import { PosPlugin } from 'plugins/plugin';
import {
  getSelectedCustomer,
  getUseCustomerRegistry,
} from 'reducers/customerSearch';
import { getSetting } from 'reducers/configs/settings';
import { AddCouponsQuickAction } from 'containers/Forms/Customers/views/CustomerView/CustomerQuickActions';

import { PreviousSales, SalesList } from './components';
import styles from './index.module.scss';
import DataTableCustomerRegistry from './components/DataTable/DataTableCustomerRegistry';
import DataTableStandardCustomers from './components/DataTable/DataTableStandardCustomers';

const useStyles = makeStyles(theme => ({
  // When using the new service, button has to be sort of transparent to not attract attention
  newSalesHistoryService: {
    backgroundColor: theme.palette.type === 'dark' ? '#424242' : '#fff',
    color: theme.palette.type === 'dark' ? 'white' : 'black',
    // Since the main button lacks Button's `color` property, by default it highlights as gray
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#424242' : '#fff',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
    },
  },
  // When using the new service, button has to have the primary (blue) color as it always was
  oldSalesHistoryService: {
    backgroundColor: theme.palette.primary.main,
    color: 'black',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'black',
    },
  },
}));

export const UICustomerViewTable: PosPlugin['UICustomerViewTable'] = ({
  customer,
}) => {
  const useOldSalesHistoryService = useSelector(
    getSetting('use_old_sales_history_service', '0'),
  );
  const dispatch: ThunkDispatch<unknown, unknown, Action> = useDispatch();
  const activeCustomer = useSelector(getSelectedCustomer);
  const buttonText = Number(useOldSalesHistoryService)
    ? 'Open previously purchased products'
    : 'View historical sales documents';
  const useCustomerRegistry = useSelector(getUseCustomerRegistry);

  const buttonStyles = useStyles();

  return (
    <>
      {useCustomerRegistry ? (
        <DataTableCustomerRegistry />
      ) : (
        <DataTableStandardCustomers />
      )}
      {activeCustomer.customerID === customer.customerID && (
        <div data-testid="quick-actions">
          <AddCouponsQuickAction />
          {/* Add more quick actions here */}
        </div>
      )}

      <Button
        variant="contained"
        color="primary"
        className={
          buttonStyles[
            Number(useOldSalesHistoryService)
              ? 'oldSalesHistoryService'
              : 'newSalesHistoryService'
          ]
        }
        fullWidth
        onClick={() =>
          dispatch(
            openPluginModalPage('PreviousSales')({
              isPopup: true,
              modalClassName: styles.modal,
              props: {
                customerID: activeCustomer.id,
              },
            }),
          )
        }
      >
        {buttonText}
      </Button>
    </>
  );
};
export const components = { PreviousSales, SalesList };
